export default { sha: 'c50c9554460c54d4717e6840efbde0503a010a12', buildNumber: 'undefined' }
